const STORAGE_KEYS = {
  IS_AUTHENTICATED: 'isAuthenticated',
  USER_EMAIL: 'userEmail',
  USER_FIRST_NAME: 'userFirstName',
  USER_LAST_NAME: 'userLastName',
  USER_COMPANY: 'userCompany',
  USER_ROLE: 'userRole',
  SESSION_EXPIRY: 'sessionExpiry',
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  ACCESS_TOKEN_EXPIRY: 'accessTokenExpiry',
  REFRESH_TOKEN_EXPIRY: 'refreshTokenExpiry',
  HAS_COMPLETED_ONBOARDING: 'hasCompletedOnboarding',
  PROJECT_ID: 'projectId',
  ORGANIZATION_ID: 'organizationId'
} as const;

/**
 * Helpers typés pour l'authentification et l'onboarding
 * Les données métier doivent passer par les hooks TanStack Query
 */
export const storage = {
  // === AUTHENTIFICATION ===
  getIsAuthenticated: () => {
    const value = localStorage.getItem(STORAGE_KEYS.IS_AUTHENTICATED);
    return value === 'true';
  },
  setIsAuthenticated: (value: boolean) => {
    if (value) {
      localStorage.setItem(STORAGE_KEYS.IS_AUTHENTICATED, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEYS.IS_AUTHENTICATED);
    }
  },

  getUserEmail: () => localStorage.getItem(STORAGE_KEYS.USER_EMAIL) || '',
  setUserEmail: (email: string) => {
    if (email) {
      localStorage.setItem(STORAGE_KEYS.USER_EMAIL, email);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_EMAIL);
    }
  },

  getUserFirstName: () => localStorage.getItem(STORAGE_KEYS.USER_FIRST_NAME) || '',
  setUserFirstName: (firstName: string) => {
    if (firstName) {
      localStorage.setItem(STORAGE_KEYS.USER_FIRST_NAME, firstName);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_FIRST_NAME);
    }
  },

  getUserLastName: () => localStorage.getItem(STORAGE_KEYS.USER_LAST_NAME) || '',
  setUserLastName: (lastName: string) => {
    if (lastName) {
      localStorage.setItem(STORAGE_KEYS.USER_LAST_NAME, lastName);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_LAST_NAME);
    }
  },

  getUserCompany: () => localStorage.getItem(STORAGE_KEYS.USER_COMPANY) || '',
  setUserCompany: (company: string) => {
    if (company) {
      localStorage.setItem(STORAGE_KEYS.USER_COMPANY, company);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_COMPANY);
    }
  },
  getUserRole: () => localStorage.getItem(STORAGE_KEYS.USER_ROLE) || '',
  setUserRole: (role: string | null) => {
    if (role) {
      localStorage.setItem(STORAGE_KEYS.USER_ROLE, role);
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER_ROLE);
    }
  },

  setSessionExpiry: (timestamp: number) => {
    localStorage.setItem(STORAGE_KEYS.SESSION_EXPIRY, timestamp.toString());
  },
  clearSessionExpiry: () => {
    localStorage.removeItem(STORAGE_KEYS.SESSION_EXPIRY);
  },

  // === TOKENS JWT ===
  getAccessToken: () => localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || null,
  setAccessToken: (token: string) => {
    if (token) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
    } else {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    }
  },

  setRefreshToken: (token: string) => {
    if (token) {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
    } else {
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    }
  },

  setAccessTokenExpiry: (date: string) => {
    if (date) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN_EXPIRY, date);
    } else {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN_EXPIRY);
    }
  },

  setRefreshTokenExpiry: (date: string) => {
    if (date) {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRY, date);
    } else {
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRY);
    }
  },

  clearTokens: () => {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN_EXPIRY);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN_EXPIRY);
  },

  // === ONBOARDING ===
  getHasCompletedOnboarding: () => {
    const value = localStorage.getItem(STORAGE_KEYS.HAS_COMPLETED_ONBOARDING);
    return value === 'true';
  },
  setHasCompletedOnboarding: (value: boolean) => {
    if (value) {
      localStorage.setItem(STORAGE_KEYS.HAS_COMPLETED_ONBOARDING, 'true');
    } else {
      localStorage.removeItem(STORAGE_KEYS.HAS_COMPLETED_ONBOARDING);
    }
  },

  // === PROJET COURANT ===
  getProjectId: () => localStorage.getItem(STORAGE_KEYS.PROJECT_ID),
  setProjectId: (projectId: string | null) => {
    if (projectId) {
      localStorage.setItem(STORAGE_KEYS.PROJECT_ID, projectId);
    } else {
      localStorage.removeItem(STORAGE_KEYS.PROJECT_ID);
    }
  },

  // === ORGANISATION COURANTE ===
  getOrganizationId: () => localStorage.getItem(STORAGE_KEYS.ORGANIZATION_ID),
  setOrganizationId: (organizationId: string | null) => {
    if (organizationId) {
      localStorage.setItem(STORAGE_KEYS.ORGANIZATION_ID, organizationId);
    } else {
      localStorage.removeItem(STORAGE_KEYS.ORGANIZATION_ID);
    }
  }
};
